module.exports = __webpack_public_path__ + "img/type1_bg3.66f94ce9.png";